// extracted by mini-css-extract-plugin
module.exports = {"vipCardMobile":"VipCardAccordion_vipCardMobile__3U3DA","cardTitle":"VipCardAccordion_cardTitle__S9ZQn","accordionBtn":"VipCardAccordion_accordionBtn__2ImvN"};